import { cn } from '~/lib/utils';
import linearIcon from '~/landing_page/Assets/Linear.png';
import linearCompletedIcon from '~/landing_page/Assets/LinearCompleted.png';
import linearInProgressIcon from '~/landing_page/Assets/LinearInProgress.png';
import styles from './WidgetCard.module.css';

export interface LinearTask {
  status: 'done' | 'in-progress' | 'open';
  label: string;
  id: string;
}

export interface LinearCardProps {
  className?: string;
  title?: string;
  tasks?: LinearTask[];
}

export const LinearCard = ({
  className,
  title = 'Sprint 34',
  tasks = [
    { status: 'done', label: 'Auth redesign', id: 'DECK-112' },
    { status: 'in-progress', label: 'Mobile nav bug', id: 'DECK-111' },
    { status: 'open', label: 'API timeout edge case', id: 'DECK-110' },
  ],
}: LinearCardProps) => {
  const statusIcon = (status: LinearTask['status']) => {
    if (status === 'done') return linearCompletedIcon;
    if (status === 'in-progress') return linearInProgressIcon;
    return linearInProgressIcon;
  };

  return (
    <div className={cn(styles.card, className)}>
      <div className={cn(styles.row, styles.rowColumn)}>
        <div className={cn(styles.body, styles.linearBody)}>
          <img src={linearIcon} className={styles.icon} alt="Linear" />
          <p className={styles.title}>{title}</p>
        </div>
        <div className={styles.statusList}>
          {tasks.map((task) => (
            <div key={task.id} className={styles.statusItem}>
              <img src={statusIcon(task.status)} className={styles.statusIcon} alt={task.status} />
              <span className={styles.statusLabel}>{task.label}</span>
              <span className={styles.statusId}>{task.id}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

LinearCard.displayName = 'LinearCard';
